// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"106":"094dc04f","148":"409e550c","261":"8985e3bf","381":"19c50df2","422":"e70205df","744":"2fa637ef","863":"f2e133b0","865":"7c7d979f"}[chunkId] + ".chunk.js";
};